function insertAfter(referenceNode, newNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

const upsellesSerializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);

	for (const key of formData.keys()) {
		const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

		if (regex.test(key)) {
			obj.properties = obj.properties || {};
			obj.properties[regex.exec(key)[2]] = formData.get(key);
		} else {
			obj[key] = formData.get(key);
		}
	}

	return JSON.stringify(obj);
};

window.upselleTheme.initActions = function initActions(upsell) {
	const template = document.querySelector('.template--checkout');
	if (upsell != null) {
		const upsellBtn = upsell.querySelectorAll('.js-product-add-upsell');
		for (let i = 0; i < upsellBtn.length; i++) {
			upsellBtn[i].addEventListener('click', function (e) {
				e.preventDefault();

				upsellBtn[i].querySelector('.loading-overlay__spinner').classList.remove('hidden');
				upsellBtn[i].setAttribute('disabled', 'disabled');
				upsellBtn[i].classList.add('is-loading');
				const cartNotification =
					document.querySelector('cart-notification') ||
					document.querySelector('cart-drawer') ||
					document.querySelector('cart-drawer-custom');
				if (cartNotification != null) {
					cartNotification.setActiveElement(document.activeElement);
				}
				const config = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/javascript',
					},
				};
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				if (cartNotification == null) {
					config.body = JSON.stringify({
						...JSON.parse(upsellesSerializeForm(e.target.closest('form'))),
					});
				} else {
					config.body = JSON.stringify({
						...JSON.parse(upsellesSerializeForm(e.target.closest('form'))),
						sections: cartNotification
							.getSectionsToRender()
							.map((section) => section.id),
						sections_url: window.location.pathname,
					});
				}

				fetch(`${window.upselleTheme.routes.cartAddUrl}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							return;
						}

						if (template == null) {
							const e = new Event('change');
							const cartDrawerItems = document.querySelector('cart-drawer-items');
							cartDrawerItems.dispatchEvent(e);
							cartNotification?.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						if (template == null) {
							upsellBtn[i].classList.remove('is-loading');
							upsellBtn[i]
								.querySelector('.loading-overlay__spinner')
								.classList.add('hidden');
							upsellBtn[i].removeAttribute('disabled');
						} else {
							location.reload();
						}
					});
			});
		}

		const upsellSelect = upsell.querySelectorAll('.js-product-select-upsell');
		for (let i = 0; i < upsellSelect.length; i++) {
			const sectionId = upsellSelect[i].getAttribute('data-id');
			const upsellId = upsellSelect[i].getAttribute('data-upsell-id');
			let productObj = document.getElementById('ProductJson-' + sectionId).innerHTML;
			productObj = JSON.parse(productObj || '{}');
			const selectCallback = function (variant, selector) {
				const productId = selector.product.id;
				const product = selector.variantIdField.closest('.js-product-upsell');
				if (product != null) {
					const productAddToCart = product.querySelector('.js-product-add-upsell');
					if (variant.available) {
						productAddToCart.removeAttribute('disabled');
					} else {
						productAddToCart.setAttribute('disabled', 'disabled');
					}
					// Compare at price
					if (variant.compare_at_price > variant.price) {
						product.querySelector('.js-product-price-number').innerHTML =
							'<span class="upsell-product__price-number--sale upsell-product__price-number"><span class="money">' +
							Shopify.formatMoney(
								variant.price,
								window.upselleTheme.money_format
									? window.upselleTheme.money_format
									: window.upselleTheme.moneyFormat,
							) +
							'</span></span>';
						product.querySelector('.js-product-price-compare').innerHTML =
							'<s class="upsell-product__price-compare"><span class="money">' +
							Shopify.formatMoney(
								variant.compare_at_price,
								window.upselleTheme.money_format
									? window.upselleTheme.money_format
									: window.upselleTheme.moneyFormat,
							) +
							'</span></s>';
					} else {
						product.querySelector('.js-product-price-number').innerHTML =
							'<span class="upsell-product__price-number"><span class="money">' +
							Shopify.formatMoney(
								variant.price,
								window.upselleTheme.money_format
									? window.upselleTheme.money_format
									: window.upselleTheme.moneyFormat,
							) +
							'</span></span>';
						product.querySelector('.js-product-price-compare').innerHTML = '';
					}
				}
			};
			new Shopify.OptionSelectors('product-select-' + upsellId + '-' + sectionId, {
				product: productObj,
				onVariantSelected: selectCallback,
				enableHistoryState: false,
			});
		}

		const flkty = upsell.querySelectorAll('.js-upsell-slider');
		for (let i = 0; i < flkty.length; i++) {
			const flktyEl = new Flickity(flkty[i], {
				prevNextButtons: false,
				pageDots: true,
				cellAlign: 'left',
				contain: true,
				groupCells: true,
				wrapAround: false,
				autoPlay: parseInt(flkty[i].getAttribute('data-auto-play')),
			});
		}
	}
};

function init() {
	let nav = document.querySelector('.main__header nav');
	if (window.upselleTheme.shipping.isfreeShippingText) {
		if (document.querySelector('.free-shipping') == null) {
			let div = document.createElement('DIV');
			div.classList.add('free-shipping');
			div.innerHTML = window.upselleTheme.shipping.freeShippingText;
			insertAfter(nav, div);
			nav = div;
		}
	}

	fetch('/cart?view=ajax', {
		method: 'GET',
		credentials: 'same-origin',
	})
		.then(function (response) {
			if (response.status !== 200) {
				// const error = new Error(response.description)
				// error.isFromServer = true
				throw error;
			}
			return response.text();
		})
		.then((data) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(data, 'text/html');
			const upsell = doc.querySelector('.upsell');

			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = 'return_to';
			input.value = '/checkout/';
			const forms = upsell.querySelectorAll('form');
			for (let i = 0; i < forms.length; i++) {
				forms[i].appendChild(input);
			}
			let index = 0;
			const upsell2 = upsell.cloneNode(true);
			const json = upsell2.querySelectorAll('.js-product-script-upsell');
			for (let i = 0; i < json.length; i++) {
				json[i].id = json[i].getAttribute('id') + index;
				const select = json[i].parentNode.querySelector('.js-product-select-upsell');

				if (select != null) {
					select.setAttribute('id', select.getAttribute('id') + index);
					select.setAttribute('data-id', select.getAttribute('data-id') + index);
				}
				index++;
			}

			if (upsell !== null) {
				if (document.querySelector('.main__header .upsell') == null) {
					insertAfter(nav, upsell);
					window.upselleTheme.initActions(upsell);
				}
			}
		})
		.catch(function () {});
}

// Initialize after Shopify renders the checkout
document.addEventListener('page:load', init);
// Reinitialize on DOM refresh
document.addEventListener('page:change', init);

document.addEventListener(
	'DOMContentLoaded',
	function () {
		const upsellElements = document.querySelectorAll('.upsell');
		for (let i = 0; i < upsellElements.length; i++) {
			window.upselleTheme.initActions(upsellElements[i]);
		}
	},
	false,
);
